import { adviceMatchesSelection } from "../lib/actionAdviceUi";
import { Pill } from "./ui";

export function PolicyBlock({ policy, testId }) {
  if (!policy) return null;
  return (
    <div data-testid={testId} className="rounded-lg border border-subtle bg-elevated/50 px-3 py-2 text-sm">
      <div className="font-mono text-[11px] uppercase tracking-widest text-slate-500">
        Beleidsuitkomst
      </div>
      <div className="mt-1 text-slate-200">
        {policy.outcome}
        <span className="ml-2 font-mono text-[11px] text-slate-500">
          {(policy.rule_codes || []).join(", ")}
        </span>
      </div>
    </div>
  );
}

export function AdviceBlock({ advice, selected }) {
  if (!advice || advice.enabled === false) return null;
  if (advice.available && !adviceMatchesSelection(selected, advice)) return null;
  if (!advice.available) {
    return (
      <div
        data-testid="ap-advice-unavailable"
        className="rounded-lg border border-subtle bg-elevated/50 px-3 py-2 text-sm"
      >
        <div className="font-mono text-[11px] uppercase tracking-widest text-slate-500">
          Advies
        </div>
        <div className="mt-1 text-slate-300">{advice.label || "Advies niet beschikbaar"}</div>
      </div>
    );
  }
  const missing = advice.missing_context;
  const missingText =
    missing === "unknown"
      ? "onbekend"
      : Array.isArray(missing) && missing.length
        ? missing.join(", ")
        : "geen";
  return (
    <div
      data-testid="ap-advice"
      className="rounded-lg border border-subtle bg-elevated/50 px-3 py-2 text-sm"
    >
      <div className="flex flex-wrap items-center gap-2">
        <div className="font-mono text-[11px] uppercase tracking-widest text-slate-500">
          Advies
        </div>
        <Pill tone="muted">{advice.label || "Gesimuleerd advies"}</Pill>
      </div>
      <div className="mt-2 space-y-1 text-slate-200" data-testid="ap-advice-body">
        <div>
          <span className="text-slate-500">Opdrachtafwijking:</span>{" "}
          {advice.task_deviation}
          {advice.deviation_code ? (
            <span className="ml-2 font-mono text-[11px] text-slate-500">
              {advice.deviation_code}
            </span>
          ) : null}
        </div>
        <div>
          <span className="text-slate-500">Ontbrekende informatie:</span> {missingText}
        </div>
      </div>
    </div>
  );
}
